import * as API_CONSTANT from "../constants";

export const getBillingTimeFrameAll = ({ startTime, endTime }) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/billing/timeframe/get/all`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify({
      startTime,
      endTime,
    }),
  }).then((res) => res.json());

export const getBillingTimeFrameByCoid = ({ coid, startTime, endTime }) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/billing/timeframe/get/coid`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify({
      coid,
      startTime,
      endTime,
    }),
  }).then((res) => res.json());

export const updateBilling = (items) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/billing/update`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify(items),
  }).then((res) => res.json());

export const paybackBilling = (items) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/billing/payback`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify(items),
  }).then((res) => res.json());

export const paymentRMS = (items) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/rms/payment/request`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify(items),
  }).then((res) => res.json());

export const bulkPublish = (items) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/billing/bulk/publish`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify(items),
  }).then((res) => res.json());
